import ErrorBoundaryWithLogger from 'components/common/ErrorBoundary/ErrorBoundary';
import BottomFooterLinksContainer from './BottomFooterLinks/BottomFooterLinksContainer';
import FooterLinksContainer from './FooterLinks/FooterLinksContainer';
import FooterMessagingContainer from './FooterMessaging/FooterMessagingContainer';
import FooterEmailSignUpContainer from './FooterEmailSignUp/FooterEmailSignUpContainer';
import './FooterPL.scss';

export default function FooterPL() {
  return (
    <div className="footerV2-container-2021" data-testid="footer-pl">
      <div className="footerV2-filler-space hmf-py-xxl" />
      <ErrorBoundaryWithLogger componentId="FooterPL-FooterEmailSignUpContainer">
        <FooterEmailSignUpContainer />
      </ErrorBoundaryWithLogger>
      <ErrorBoundaryWithLogger componentId="FooterPl-FooterMessagingContainer">
        <FooterMessagingContainer />
      </ErrorBoundaryWithLogger>
      <ErrorBoundaryWithLogger componentId="FooterPL-FooterLinksContainer">
        <FooterLinksContainer />
      </ErrorBoundaryWithLogger>
      <ErrorBoundaryWithLogger componentId="FooterPL-BottomFooterLinksContainer">
        <BottomFooterLinksContainer />
      </ErrorBoundaryWithLogger>
    </div>
  );
}
